<script>
import TrainingCard from './TrainingCard'
export default {
  components: {
    TrainingCard,
  },
  props: {
    training: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeName: 'first',
      managerImg: '',
      professionalData: {},
      softData: {},
      learnData: {},
    }
  },
  created() {
    const vm = this
    vm.managerImg = vm.training['training-map'].management.image
    vm.professionalData = vm.training['training-map'].profession
    vm.softData = vm.training['training-map'].softness
    vm.learnData = vm.training['training-map'].learning
  },
  methods: {},
}
</script>
<template>
  <div :class="$style.training">
    <div class="training__box">
      <div class="container bg-overly">
        <div class="training-box">
          <BaseSectionTitle title="零壹科技 教育訓練MAP" class="text-center" />
          <el-tabs v-model="activeName" :stretch="true">
            <el-tab-pane label="管理需求" name="first">
              <img :src="managerImg" alt="" />
            </el-tab-pane>
            <el-tab-pane label="專業需求" name="second">
              <TrainingCard :data-list="professionalData"></TrainingCard>
            </el-tab-pane>
            <el-tab-pane label="軟性需求" name="third">
              <TrainingCard :data-list="softData"></TrainingCard>
            </el-tab-pane>
            <el-tab-pane label="學習成長" name="fourth">
              <TrainingCard :data-list="learnData"></TrainingCard>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.training {
  background: $color-gray-2;
  :global {
    .training {
      &__box {
        .container {
          .training-box {
            padding-top: 70px;
            padding-bottom: 70px;
            .detail {
              margin-bottom: 60px;
              font-size: 1.125rem;
              color: $color-gray-6;
              text-align: center;
            }
            .el-tabs__header {
              margin: 0 0 58px;
            }
            .el-tabs__item {
              font-size: 18px;
              margin-bottom: 20px;
            }
            .is-top {
              color: $color-gray-6;
            }
            .is-active {
              color: $color-primary;
            }
            @include max-md {
              padding: 40px 10px;
              .detail {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>